import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import SubscriptionAppBar from '../../components/SubscriptionAppBar';
import Button from '../../../../components/Button';

import * as gqlTypes from '../../../../types/gql-op-types';
import { inAppCancellation as events } from '../../../../lib/analytics/events';
import Chooser from '../../../../components/Chooser';
import { useHistory, useLocation } from 'react-router-dom';
import AppPaths from '../../../../AppPaths';
import { BaseInAppCancellationState } from '../util/types';
import ErrorScreen from '../../components/ErrorScreen/ErrorScreen';

export default function TellUsMore() {
  const { t } = useTranslation();
  const history = useHistory();
  const { device } = usePurchaseSubscriptionContext();
  const location = useLocation<BaseInAppCancellationState>();
  const { subscriptionCategory } = location.state;
  const [selectedCancelReason, setSelectedCancelReason] = useState<gqlTypes.zendeskCancellationReason | undefined>(
    undefined,
  );

  if (!device.subscription?.id) {
    return <ErrorScreen />;
  }

  events.pageLoad({ petId: device.pet!.id, subscriptionCategory }, 'Tell Us More');

  const handleContinue = () => {
    if (!selectedCancelReason) {
      throw new Error(t('something_went_wrong'));
    }
    events.tellUsMoreContinue({
      petId: device.pet?.id,
      cancellationReason: selectedCancelReason,
      subscriptionCategory,
    });
    history.push({
      pathname: AppPaths.Subscription.ContactCx(device.moduleId),
      state: { selectedCancelReason, subscriptionCategory },
      search: window.location.search,
    });
  };

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBar
          backButtonAnalyticsEvent={() => events.tellUsMoreBack({ petId: device.pet?.id, subscriptionCategory })}
          closeButtonAnalyticsEvent={() => events.tellUsMoreClose({ petId: device.pet?.id, subscriptionCategory })}
        />
        <div className={styles.subscriptionContainer}>
          <h1>{t('tell_us_more')}</h1>
          <p>{t('to_help_us_guide_you_in_the_right_direction_please_select_one_of_the_options_below')}</p>

          <div className={styles.reasonHeader}>{t('reason_for_cancellation')}</div>
          <div className={styles.content}>
            <div className={styles.content}>
              <Chooser
                onSelect={(selectedReason) => {
                  setSelectedCancelReason(selectedReason);
                }}
                selectedOption={selectedCancelReason}
                groups={[
                  {
                    options: [
                      {
                        content: t('my_dogs_location_is_not_correct'),
                        value: gqlTypes.zendeskCancellationReason.LOCATION_REPORTS_INCORRECT,
                      },
                      {
                        content: t('the_app_took_too_long_to_notify_me'),
                        value: gqlTypes.zendeskCancellationReason.TOOK_TOO_LONG_TO_NOTIFY,
                      },
                      {
                        content: t('the_collars_battery_drains_too_quickly'),
                        value: gqlTypes.zendeskCancellationReason.BATTERY_DRAINS_TOO_QUICKLY,
                      },
                      {
                        content: t('other'),
                        value: gqlTypes.zendeskCancellationReason.OTHER,
                      },
                    ],
                  },
                ]}
                showRadio
                compact
              />
            </div>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button className={styles.button} disabled={selectedCancelReason === undefined} onClick={handleContinue}>
            {t('continue')}
          </Button>
          {/* styles.buttonSpacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
